const integration = require('@segment/analytics.js-integration');

/**
 * Expose `LinkedIn Insight Tag` integration.
 */

const Linkedin = (module.exports = integration('LinkedIn Insight Tag')
    .option('partnerId', '')
    .mapping('conversions')
    .tag(
      '<script src="https://snap.licdn.com/li.lms-analytics/insight.min.js"></script>'
    )
);

Linkedin.prototype.initialize = function() {
  // We require a Partner ID to run this integration.
  if (!this.options.partnerId) return;

  window._linkedin_data_partner_id = this.options.partnerId;
  window._linkedin_data_partner_ids = [this.options.partnerId];

  this.load(this.ready);
};

Linkedin.prototype.loaded = function() {
  return window._linkedin_data_partner_id;
};

Linkedin.prototype.track = function(track) {
  const event = track.event();
  const conversions = this.conversions(event);

  if (conversions.length) {
    conversions.forEach((id) => {
      let conversionId = id;
      if (typeof conversionId === 'string') {
        conversionId = parseInt(conversionId);
      }
      window.lintrk('track', {
        conversion_id: conversionId,
      });
    });
  }

};
